import { useEffect, useRef, useState } from 'react';
import confetti from 'canvas-confetti';
import './WinnerCelebration.css';

const CELEBRATION_DURATION = 5500;
const EMOTE_DROP_COUNT = 24;
const CONFETTI_COLORS = ['#ff4d6d', '#ffd166', '#06d6a0', '#4cc9f0', '#9b5de5'];

const emoteAsset = (fileName) =>
	`${process.env.REACT_APP_CDN_BASE_URL}/auction/winner-emotes/${fileName}`;

const WINNER_EMOTES = [
	{ name: 'KEKW', src: emoteAsset('kekw.png') },
	{ name: 'Kappa', src: emoteAsset('kappa.png') },
	{ name: 'LUL', src: emoteAsset('lul.png') },
	{ name: 'Hypers', src: emoteAsset('hypers.png') },
	{ name: 'PogChomp', src: emoteAsset('pogchomp.png') },
	{ name: 'peepoHappy', src: emoteAsset('peepo-happy.png') },
];

const pickRandomEmotes = () => {
	const firstIndex = Math.floor(Math.random() * WINNER_EMOTES.length);
	let secondIndex = Math.floor(Math.random() * (WINNER_EMOTES.length - 1));

	if (secondIndex >= firstIndex) {
		secondIndex += 1;
	}

	return [WINNER_EMOTES[firstIndex], WINNER_EMOTES[secondIndex]];
};

const createEmoteDrops = () => {
	const selectedEmotes = pickRandomEmotes();

	return Array.from({ length: EMOTE_DROP_COUNT }, (_, index) => ({
		id: `${Date.now()}-${index}`,
		emote: selectedEmotes[index % selectedEmotes.length],
		left: Math.random() * 94,
		delay: Math.random() * 1.8,
		duration: 3.3 + Math.random() * 1.8,
		drift: Math.round((Math.random() - 0.5) * 180),
		rotation: Math.round((Math.random() - 0.5) * 520),
		size: Math.round(54 + Math.random() * 42),
	}));
};

export const WinnerCelebration = ({ active }) => {
	const canvasRef = useRef(null);
	const [emoteDrops, setEmoteDrops] = useState([]);

	useEffect(() => {
		if (!active) {
			setEmoteDrops([]);
			return undefined;
		}

		setEmoteDrops(createEmoteDrops());
		const clearDropsTimer = window.setTimeout(() => setEmoteDrops([]), CELEBRATION_DURATION + 500);

		return () => window.clearTimeout(clearDropsTimer);
	}, [active]);

	useEffect(() => {
		if (!active || !canvasRef.current) {
			return undefined;
		}

		const fireConfetti = confetti.create(canvasRef.current, {
			resize: true,
			useWorker: true,
		});
		const endTime = Date.now() + CELEBRATION_DURATION;
		let animationFrameId;

		const fireCannons = () => {
			fireConfetti({
				particleCount: 2,
				angle: 60,
				spread: 55,
				startVelocity: 46,
				origin: { x: 0, y: 0.72 },
				colors: CONFETTI_COLORS,
				ticks: 210,
				disableForReducedMotion: true,
			});
			fireConfetti({
				particleCount: 2,
				angle: 120,
				spread: 55,
				startVelocity: 46,
				origin: { x: 1, y: 0.72 },
				colors: CONFETTI_COLORS,
				ticks: 210,
				disableForReducedMotion: true,
			});

			if (Date.now() < endTime) {
				animationFrameId = window.requestAnimationFrame(fireCannons);
			}
		};

		fireCannons();

		return () => {
			window.cancelAnimationFrame(animationFrameId);
			fireConfetti.reset();
		};
	}, [active]);

	if (!active) {
		return null;
	}

	return (
		<div className="winner-celebration" aria-hidden="true">
			<canvas ref={canvasRef} className="winner-celebration__canvas" />
			<div className="winner-celebration__emote-rain">
				{emoteDrops.map((drop) => (
					<img
						key={drop.id}
						className="winner-celebration__emote"
						src={drop.emote.src}
						alt=""
						style={{
							left: `${drop.left}%`,
							width: `${drop.size}px`,
							'--emote-delay': `${drop.delay}s`,
							'--emote-duration': `${drop.duration}s`,
							'--emote-drift': `${drop.drift}px`,
							'--emote-rotation': `${drop.rotation}deg`,
						}}
					/>
				))}
			</div>
		</div>
	);
};
